import { ApiCallGet, ApiCallPost } from "../../../api/apiConfig/apiCall";
import { ApiConfig } from "../../../api/apiConfig/apiConfig";

const url = (path) => `${ApiConfig.baseUrl}v1/otc-trade${path}`;

export const OtcTradeApi = {
  pairs: (category) => ApiCallGet(url(`/pairs?category=${encodeURIComponent(category || "")}`)),
  balance: (asset) => ApiCallGet(url(`/balance/${encodeURIComponent(asset)}`)),
  quote: (body) => ApiCallPost(url("/quotes"), body),
  confirm: (quoteId, idempotencyKey) =>
    ApiCallPost(url(`/quotes/${quoteId}/confirm`), { idempotencyKey }, { "Idempotency-Key": idempotencyKey }),
  chooseSettlement: (id, body) => ApiCallPost(url(`/requests/${id}/settlement`), body || {}),
  chooseDd: (id, body) => ApiCallPost(url(`/requests/${id}/due-diligence`), body || {}),
  requests: () => ApiCallGet(url("/requests")),
  cancel: (id) => ApiCallPost(url(`/requests/${id}/cancel`), {}),
};
